const TOC = [
    { n: "1", label: "Quem trata os seus dados", href: "#s1" },
    { n: "2", label: "Que dados coletamos, e para quê", href: "#s2" },
    { n: "3", label: "Com quem são compartilhados", href: "#s3" },
    { n: "4", label: "Por quanto tempo guardamos", href: "#s4" },
    { n: "5", label: "Cookies e medição de acesso", href: "#s5" },
    { n: "6", label: "Seus direitos", href: "#s6" },
    { n: "7", label: "Segurança", href: "#s7" },
    { n: "8", label: "Empresas fora do Brasil", href: "#s8" },
    { n: "9", label: "Mudanças nesta política", href: "#s9" },
    { n: "10", label: "Falar com a gente", href: "#s10" }
];

const DADOS = [
    { dado: "Nome", uso: "Saber como te chamar na resposta e na conversa.", base: "Interesse legítimo — art. 7º, IX" },
    { dado: "WhatsApp ou telefone", uso: "Responder ao pedido de diagnóstico pelo canal que você escolheu.", base: "Interesse legítimo — art. 7º, IX" },
    { dado: "E-mail (opcional)", uso: "Alternativa de contato quando a ligação não completa. Só se você preencher.", base: "Interesse legítimo — art. 7º, IX" },
    { dado: "Descrição do seu caso e situação escolhida", uso: "Entender o problema antes da conversa, para não fazer você repetir tudo.", base: "Interesse legítimo — art. 7º, IX" },
    { dado: "Dados de contrato, quando o projeto acontece", uso: "Emitir nota fiscal, cumprir o contrato e prestar suporte depois da entrega.", base: "Execução de contrato e obrigação legal — art. 7º, V e II" }
];

const PRAZOS = [
    { prazo: "24 meses", oQue: "Pedidos de diagnóstico que não viraram projeto. Depois desse prazo, apagamos nome, telefone e a descrição enviada." },
    { prazo: "Durante o contrato", oQue: "Dados de clientes ativos, enquanto o projeto e o suporte estiverem em andamento." },
    { prazo: "5 anos após o contrato", oQue: "Apenas o que a legislação fiscal e civil obriga a manter — nota fiscal, contrato e registros de pagamento." }
];

const DIREITOS = [
    { titulo: "Saber o que temos", desc: "Confirmação de que tratamos seus dados e acesso ao conteúdo." },
    { titulo: "Corrigir", desc: "Ajustar dado incompleto, desatualizado ou errado." },
    { titulo: "Apagar", desc: "Eliminação dos dados, salvo o que a lei fiscal obriga a guardar." },
    { titulo: "Levar embora", desc: "Portabilidade dos dados para outro fornecedor, se você pedir." },
    { titulo: "Saber com quem dividimos", desc: "Informação sobre com quais prestadores os dados passaram." },
    { titulo: "Se opor ao uso", desc: "Contestar o tratamento feito com base em interesse legítimo." }
];

export { TOC, DADOS, PRAZOS, DIREITOS };
